// extracted by mini-css-extract-plugin
module.exports = {"youtubeWrapper":"finance-explained_youtubeWrapper__vhlCZ","youtubeWrapperTitle":"finance-explained_youtubeWrapperTitle__QK6um"};